import { OrganizationKeyName } from "../../../model/Organization";
import { NewsListItem } from "../model/NewsListSuccessResponse";

export const GET_UNASSIGNED_NEWS_LIST_SUCCESS =
  "SHOP:GET_UNASSIGNED_NEWS_LIST_SUCCESS";

export const getUnassignedNewsListSuccessAction = (
  organization: OrganizationKeyName,
  data: NewsListItem[]
) => ({
  type: GET_UNASSIGNED_NEWS_LIST_SUCCESS as typeof GET_UNASSIGNED_NEWS_LIST_SUCCESS,
  organization,
  data,
});

export type GetUnassignedNewsListSuccessAction = ReturnType<
  typeof getUnassignedNewsListSuccessAction
>;
